export var MultifactorAuthenticationIA = function MultifactorAuthenticationIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return MULTIFACTOR_AUTHENTICATION_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [MULTIFACTOR_AUTHENTICATION_DESCRIPTION(strictLocalize), MULTIFACTOR_AUTHENTICATION_CONTACT_US(strictLocalize)];
    }
  };
};
var MULTIFACTOR_AUTHENTICATION_TITLE = function MULTIFACTOR_AUTHENTICATION_TITLE(strictLocalize) {
  return strictLocalize({
    id: "A77NhJ",
    defaultMessage: "Multifactor authentication"
  });
};
var MULTIFACTOR_AUTHENTICATION_DESCRIPTION = function MULTIFACTOR_AUTHENTICATION_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "q2lRAt",
    defaultMessage: "At Faire, we have implemented security measures to safeguard your account from unauthorized access. As part of these measures, we may ask for additional information, such as a Multi-Factor Authentication (MFA) code, to ensure that only you have access to your account. This is done to protect the security and privacy of your account and prevent any potential unauthorized activities."
  });
};
var MULTIFACTOR_AUTHENTICATION_CONTACT_US = function MULTIFACTOR_AUTHENTICATION_CONTACT_US(strictLocalize) {
  return strictLocalize({
    id: "L5tq/m",
    defaultMessage: "If you have any questions or concerns about multifactor authentication, please contact us."
  });
};